import PropTypes from 'prop-types';
import React, { useEffect, useCallback } from 'react';

export default function Badging({ count }) {
    const setBadge = useCallback(async (...args) => {
        if ('setAppBadge' in navigator) {
            await navigator.setAppBadge(...args);
        }
    }, []);

    const clearBadge = useCallback(async () => {
        if ('clearAppBadge' in navigator) {
            await navigator.clearAppBadge();
        }
    }, []);

    useEffect(() => {
        setBadge(count);

        return () => {
            clearBadge();
        };
    }, [count]);

    return null;
}

Badging.propTypes = {
    count: PropTypes.number,
};
